import execWm from "@/../../hypetrain/static/img/exec-wm.png";
import { Colors } from "@blueprintjs/core";
import { Link } from "react-router-dom";

import { getStartPageURL } from "@/components/helpers/url-utils";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import MobileNav from "@/components/nav/PublicNav/MobileNav";
import NavLinks from "@/components/nav/PublicNav/NavLinks";
import { PrimaryLinkBtn, Container } from "@/components/pieces/bootstrap";
import {
  BRAND_PURPLE,
  NAV_Z_INDEX,
  STANDARD_NAV_HEIGHT,
} from "@/css/constants";

interface ExecNavProps {
  fullWidth?: boolean;
}

export default function ExecNav({ fullWidth = false }: ExecNavProps) {
  return (
    <div className="public-header" style={{ zIndex: NAV_Z_INDEX }}>
      <Container maxWidth={fullWidth ? "100%" : 1170} px={24}>
        <Flex
          minHeight={STANDARD_NAV_HEIGHT - 16}
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex alignItems="center">
            <Box minWidth={120}>
              <Link to={"/"}>
                <img src={execWm} height={24} />
              </Link>
            </Box>
            <Media greaterThan="md">
              <NavLinks pill={true} />
            </Media>
          </Flex>
          <Flex />
          <Media greaterThan="md">
            <Flex>
              <Link style={{ color: BRAND_PURPLE }} to={"/login"}>
                Login
              </Link>
              <Box mx={2}>&bull;</Box>
              <Link
                style={{ color: BRAND_PURPLE }}
                to={getStartPageURL("?nextPath=/roleplays")}
              >
                Get Started
              </Link>
            </Flex>
          </Media>
          <Media lessThan="lg">
            <Flex>
              <PrimaryLinkBtn
                style={{
                  color: Colors.WHITE,
                  backgroundColor: BRAND_PURPLE,
                  marginLeft: "2rem",
                }}
                to={getStartPageURL()}
              >
                Get Started
              </PrimaryLinkBtn>
              <Flex ml={3} alignItems="center">
                <MobileNav hideLogin={false} />
              </Flex>
            </Flex>
          </Media>
        </Flex>
      </Container>
    </div>
  );
}
